import styled from "styled-components";

import { Switch } from "@/components/ui/switch";

export const SwitchStyled = styled(Switch)`
  transition: all 0.2s ease-out;
  cursor: pointer;

  span {
    transition: all 0.3s ease-out;
  }
`;
